import styles from "./AboutPage.module.scss";

interface LogoCellProps {
    src: string;
    alt: string;
    imgClassName?: string;
    divClassName?: string;
}

export const LogoCell = ({
    src,
    alt,
    imgClassName = "",
    divClassName = "",
}: LogoCellProps) => (
    <div className={`${styles.cell} ${divClassName}`}>
        <img className={`${styles.img} ${imgClassName}`} src={src} alt={alt} />
    </div>
);
